import React from 'react';
import i18n from '../../../i18n/i18n';
import { reportFrontendError } from '../../../utils/errorReporter';
import { getPortal, PORTALS } from '../../../utils/portal';

// 🏠 Accueil RÉEL selon le portail courant (déduit du hostname). Sur admin/company, la racine « / »
// est mappée en « Navigate → /admin/login » (App.js) : y renvoyer = écran de connexion = « déconnexion »
// ressentie. On vise donc l'accueil du portail (/admin, /driver), pas « / ».
const portalHome = () => {
  const p = getPortal();
  if (p === PORTALS.SUPER || p === PORTALS.COMPANY) return '/admin';
  if (p === PORTALS.DRIVER) return '/driver';
  return '/';
};

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // Remontée centralisée (crash React) via le reporter unique → table incidents.
    reportFrontendError({
      type: 'frontend_crash',
      message: error?.message || String(error),
      stack: error?.stack,
      componentStack: info?.componentStack,
      page: typeof window !== 'undefined' ? window.location.pathname : '',
    });
  }

  render() {
    const t = (key, fallback) => i18n.t(key, { ns: 'common', defaultValue: fallback });

    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: '60vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '2rem',
          textAlign: 'center',
          fontFamily: 'sans-serif'
        }}>
          <div style={{ fontSize: 48, marginBottom: 16 }}>🚌</div>
          <h2 style={{ color: '#333', marginBottom: 8 }}>
            {t('errorBoundary.title', 'Quelque chose s\'est mal passé')}
          </h2>
          <p style={{ color: '#666', marginBottom: 24, maxWidth: 400 }}>
            {t('errorBoundary.message', 'Une erreur inattendue est survenue. Nos équipes ont été alertées.')}
          </p>
          <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', justifyContent: 'center' }}>
            <button
              onClick={() => this.setState({ hasError: false, error: null })}
              style={{
                padding: '10px 20px',
                background: '#667eea',
                color: '#fff',
                border: 'none',
                borderRadius: 8,
                cursor: 'pointer',
                fontWeight: 600
              }}
            >
              {t('errorBoundary.retry', 'Réessayer')}
            </button>
            <button
              onClick={() => { window.location.href = portalHome(); }}
              style={{
                padding: '10px 20px',
                background: '#fff',
                color: '#667eea',
                border: '2px solid #667eea',
                borderRadius: 8,
                cursor: 'pointer',
                fontWeight: 600
              }}
            >
              {t('errorBoundary.backHome', 'Retour à l\'accueil')}
            </button>
          </div>
          {process.env.NODE_ENV === 'development' && this.state.error && (
            <details style={{ marginTop: 24, textAlign: 'left', maxWidth: 600, fontSize: 12, color: '#999' }}>
              <summary style={{ cursor: 'pointer' }}>
                {t('errorBoundary.devDetails', 'Détails (dev)')}
              </summary>
              <pre style={{ overflow: 'auto', padding: 8, background: '#f5f5f5', borderRadius: 4, marginTop: 8 }}>
                {this.state.error.message}{'\n'}{this.state.error.stack}
              </pre>
            </details>
          )}
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
